import { PROGRAM_TYPES } from 'utils/program/helpers'

/**
 * Extracts grade values as-is from metadata values
 * @param {Array} metadataValues - Array of metadata objects
 * @returns {string} - The grade value as-is, or empty string if not found
 */
export const extractGradeValue = metadataValues => {
  if (!metadataValues || !Array.isArray(metadataValues)) {
    console.log('no metadata values')
    return ''
  }

  const gradeMetadata = metadataValues.find(
    m => m.contentType === 'MetadataGrade',
  )
  return gradeMetadata?.grade || ''
}

/**
 * Gets the breadcrumb navigation path based on the current program type
 * @param {string} currentProgram - The current program type from PROGRAM_TYPES
 * @returns {string} - The breadcrumb navigation path
 */
export const getBreadcrumbPath = currentProgram => {
  if (
    currentProgram === PROGRAM_TYPES.ELEMENTARY ||
    currentProgram === PROGRAM_TYPES.ELEMENTARY_TIER_2
  ) {
    return '/product/elementary/lessons'
  } else if (
    currentProgram === PROGRAM_TYPES.MIDDLE_SCHOOL ||
    currentProgram === PROGRAM_TYPES.MIDDLE_SCHOOL_TIER_2
  ) {
    return '/product/middle-school/lessons'
  } else if (currentProgram === PROGRAM_TYPES.HIGH_SCHOOL) {
    return '/product/high-school/learning-experiences'
  }

  // Fallback to dashboard
  return '/dashboard'
}

/**
 * Gets the breadcrumb text based on the current program type
 * @param {string} currentProgram - The current program type from PROGRAM_TYPES
 * @param {string} productTabTitle - Fallback title if program type is unknown
 * @returns {string} - The breadcrumb text
 */
export const getBreadcrumbText = (
  currentProgram,
  productTabTitle = 'Dashboard',
) => {
  if (
    currentProgram === PROGRAM_TYPES.ELEMENTARY ||
    currentProgram === PROGRAM_TYPES.ELEMENTARY_TIER_2
  ) {
    return 'Elementary Lessons'
  } else if (
    currentProgram === PROGRAM_TYPES.MIDDLE_SCHOOL ||
    currentProgram === PROGRAM_TYPES.MIDDLE_SCHOOL_TIER_2
  ) {
    return 'Middle School Lessons'
  } else if (currentProgram === PROGRAM_TYPES.HIGH_SCHOOL) {
    return 'High School Lessons'
  }

  // Fallback to productTabTitle or Dashboard
  return productTabTitle || 'Dashboard'
}
